// Константы, нужные экранам (а также внешним кольцам — они импортируют внутрь).
export const DOMAIN = 'mdev.kz'

export const CUSTOMER_PATH = 'customer'

export const prefixCookie = '_SA_.'

export const COORDS_ASTANA = {
  LAT: 71.456191,
  LON: 51.134224,
}
